import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import CookieConsent from '../common/CookieConsent';
import HelpDrawer from '../common/HelpDrawer';

const Layout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className="app-shell flex h-screen overflow-hidden font-sans transition-colors">
      {/* GLOBAL OVERLAYS */}
      <CookieConsent />
      {/* OnboardingGuide fjernet etter ønske */}
      <HelpDrawer />

      {/* Sidebar - Fixed width */}
      <Sidebar
        isOpen={isMobileSidebarOpen}
        onClose={() => setIsMobileSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative transition-all duration-200">
        {/* Header - Fixed height */}
        <Header onOpenSidebar={() => setIsMobileSidebarOpen(true)} />

        {/* Page Content - Scrollable */}
        <main className="page-surface flex-1 min-w-0 overflow-auto scroll-smooth transition-colors">
          <div className="max-w-[1600px] mx-auto p-4 md:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;